import { create } from "zustand";

interface RedirectStore {
  takeToCompanies: string | null;
  takeToCompaniesCards: string | null;

  setTakeToCompanies: (data: string | null) => void;
  setTakeToCompaniesCards: (data: string | null) => void;
}

export const useRedirectStore = create<RedirectStore>()(set => ({
  takeToCompanies: null,
  takeToCompaniesCards: null,

  setTakeToCompanies: data => set({ takeToCompanies: data }),
  setTakeToCompaniesCards: data => set({ takeToCompaniesCards: data })
}));
